module.exports = __webpack_public_path__ + "img/1.d24fc2a0.jpg";